<div class="container-fluid">
  <div class="container-fluid">
    <h1
      style="
        font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto,
          Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;
        text-align: center;
      "
    >
      All things To-Do
    </h1>
  </div>

  <div class="container-fluid">
    <div class="row justify-content-between" style="margin-bottom: 2%">
      <div class="col-4">
        <button type="button" class="btn btn-dark" (click)="onBack()">
          Back
        </button>
      </div>
      <div class="col-4">
        <div class="container-fluid">
          <div class="form-check form-check-inline">
          <label class="form-check-label">Order by: </label>
          </div>
          <div class="form-check form-check-inline">
            <input
              class="form-check-input"
              type="radio"
              name="inlineRadioOptions"
              id="inlineRadio1"
              value="id"
              [(ngModel)]="orderBy"
            />
            <label class="form-check-label" for="inlineRadio1">Id</label>
          </div>
          <div class="form-check form-check-inline">
            <input
              class="form-check-input"
              type="radio"
              name="inlineRadioOptions"
              id="inlineRadio2"
              value="title"
              [(ngModel)]="orderBy"
            />
            <label class="form-check-label" for="inlineRadio2">Title</label>
          </div>
          <div class="form-check form-check-inline">
            <input
              class="form-check-input"
              type="radio"
              name="inlineRadioOptions"
              id="inlineRadio3"
              value="status"
              [(ngModel)]="orderBy"
            />
            <label class="form-check-label" for="inlineRadio3">Status</label>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="container-fluid">
    <table class="table table-dark table-striped">
      <thead>
        <tr style="background-color: black; color: white; font-style: bold">
          <th class="td">ID</th>
          <th class="td">Title</th>
          <th class="td">Status</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let todo of todos | paginator: page:orderBy">
          <td class="td">{{ todo.id }}</td>
          <td class="td">{{ todo.title }}</td>
          <td class="td">
            <div *ngIf="todo.completed; else elseBlock" style="color: green">
              Completed
            </div>
            <ng-template #elseBlock>
              <div style="color: red">Incompleted</div></ng-template
            >
          </td>
        </tr>
      </tbody>
    </table>
  </div>

  <div
    class="contaner-fluid"
    *ngIf="(todos | paginator: page:orderBy).length === 0"
  >
    <h1 style="text-align: center">UPS! NO MORE RECORDS:(</h1>
  </div>

  <div class="container-fluid">
    <div class="row justify-content-between" style="text-align: center">
      <div class="col-4">
        <button class="btn btn-outline-dark" (click)="prevPage()">
          Previous
        </button>
      </div>
      <div class="col-4">
        <button
          class="btn btn-outline-dark"
          (click)="nextPage()"
          [disabled]="(todos | paginator: page:orderBy).length === 0"
        >
          Next
        </button>
      </div>
    </div>
  </div>

  <div class="d-flex justify-content-center">
    <div class="spinner-grow text-dark" role="status" *ngIf="loading">
      <span class="visually-hidden">Loading...</span>
    </div>
  </div>
  
  <p style="font-style: italic; margin-top: 2%">Data from JSONPlaceholder</p>
</div>


